module.exports = __webpack_public_path__ + "img/ahorcadoNuevo4.b97ed2db.png";